import { useState } from 'react'
import { useStripeCheckout } from '../hooks/useStripeCheckout'

export default function CTA() {
  const { handleCheckout, isLoading } = useStripeCheckout()
  const [couponCode, setCouponCode] = useState('')
  const [showCoupon, setShowCoupon] = useState(false)

  return (
    <section className="section-padding bg-gradient-to-r from-primary-600 to-accent-600">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Prepare for Genesis?
          </h2>
          <p className="text-xl text-primary-100 mb-4 max-w-2xl mx-auto">
            Get the complete Professional Pack with full toolkits, templates, and enterprise-ready 
            documentation to accelerate your Genesis readiness.
          </p>
          <p className="text-lg font-semibold text-white mb-6">
            $199 • One-Time Purchase
          </p>
          
          {showCoupon ? (
            <div className="mb-6 max-w-md mx-auto space-y-3">
              <input
                type="text"
                placeholder="Enter coupon code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                className="w-full px-4 py-3 rounded-lg text-gray-900 bg-white border border-gray-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary-600"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleCheckout(couponCode.trim() || undefined)
                  }
                }}
              />
              <button
                onClick={(e) => {
                  e.preventDefault()
                  setShowCoupon(false)
                  setCouponCode('')
                }}
                className="text-sm text-primary-200 hover:text-white"
              >
                Cancel
              </button>
            </div>
          ) : (
            <div className="mb-6">
              <button
                onClick={(e) => {
                  e.preventDefault()
                  setShowCoupon(true)
                }}
                className="text-sm text-primary-200 hover:text-white underline"
              >
                Have a coupon code?
              </button>
            </div>
          )}
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => handleCheckout(couponCode.trim() || undefined)}
              disabled={isLoading}
              className="btn-primary bg-white text-primary-600 hover:bg-primary-50 text-lg px-8 py-4 disabled:opacity-50"
            >
              {isLoading ? 'Processing...' : 'Buy for $199'}
            </button>
            <a
              href="https://github.com/gentlyventures/harboragent"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary border-white text-white hover:bg-white/10 text-lg px-8 py-4"
            >
              Start with Free Tier
            </a>
          </div>
          <p className="mt-6 text-sm text-primary-200">
            Questions? Contact us at support@gentlyventures.com
          </p>
        </div>
      </div>
    </section>
  )
}

